/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOOTPResponseDTO } from '../models/ApiResponseDTOOTPResponseDTO';
import type { ApiResponseDTOSubmitSelfieResponseDTO } from '../models/ApiResponseDTOSubmitSelfieResponseDTO';
import type { ApiResponseDTOUpdateTokenResponseDTO } from '../models/ApiResponseDTOUpdateTokenResponseDTO';
import type { ApiResponseDTOVoid } from '../models/ApiResponseDTOVoid';
import type { CommitProfileUpdateDTO } from '../models/CommitProfileUpdateDTO';
import type { RequestEmailUpdateOtpDTO } from '../models/RequestEmailUpdateOtpDTO';
import type { RequestPhoneUpdateOtpDTO } from '../models/RequestPhoneUpdateOtpDTO';
import type { SubmitSelfieRequestDTO } from '../models/SubmitSelfieRequestDTO';
import type { VerifyUpdateOtpDTO } from '../models/VerifyUpdateOtpDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProfileUpdateApiService {

    /**
     * Commit email update
     * Updates the email after OTP and selfie verification have passed
     * @param requestBody 
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static commitEmailUpdate(
requestBody: CommitProfileUpdateDTO,
): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/profile/email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Request OTP to update email
     * Sends a 6-digit OTP to the new email address for verification
     * @param requestBody 
     * @returns ApiResponseDTOOTPResponseDTO OK
     * @throws ApiError
     */
    public static requestEmailUpdateOtp(
requestBody: RequestEmailUpdateOtpDTO,
): CancelablePromise<ApiResponseDTOOTPResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/profile/email/otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Conflict`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Verify email update OTP
     * Verifies the OTP sent to the new email and returns an updateToken
     * @param requestBody 
     * @returns ApiResponseDTOUpdateTokenResponseDTO OK
     * @throws ApiError
     */
    public static verifyEmailUpdateOtp(
requestBody: VerifyUpdateOtpDTO,
): CancelablePromise<ApiResponseDTOUpdateTokenResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/profile/email/otp/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Commit phone number update
     * Updates the phone number after OTP and selfie verification have passed
     * @param requestBody 
     * @returns ApiResponseDTOVoid OK
     * @throws ApiError
     */
    public static commitPhoneUpdate(
requestBody: CommitProfileUpdateDTO,
): CancelablePromise<ApiResponseDTOVoid> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/profile/phone',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Request OTP to update phone number
     * Sends a 6-digit OTP to the new phone number via SMS, WhatsApp, or voice call
     * @param requestBody 
     * @returns ApiResponseDTOOTPResponseDTO OK
     * @throws ApiError
     */
    public static requestPhoneUpdateOtp(
requestBody: RequestPhoneUpdateOtpDTO,
): CancelablePromise<ApiResponseDTOOTPResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/profile/phone/otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Conflict`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Verify phone update OTP
     * Verifies the OTP sent to the new phone number and returns an updateToken
     * @param requestBody 
     * @returns ApiResponseDTOUpdateTokenResponseDTO OK
     * @throws ApiError
     */
    public static verifyPhoneUpdateOtp(
requestBody: VerifyUpdateOtpDTO,
): CancelablePromise<ApiResponseDTOUpdateTokenResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/profile/phone/otp/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Submit selfie for profile update verification
     * Submits a facial selfie for liveness and identity verification during a phone or email update
     * @param requestBody 
     * @returns ApiResponseDTOSubmitSelfieResponseDTO OK
     * @throws ApiError
     */
    public static submitProfileUpdateSelfie(
requestBody: SubmitSelfieRequestDTO,
): CancelablePromise<ApiResponseDTOSubmitSelfieResponseDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/profile/selfie',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
